import GroupingsModel from "./GroupingsModel.js";
import GeoLayerEditor from "../../dataViewers/map/mapbox/renderers/GeoLayerEditor.js";
const install = molten => {
  molten.addPlugin('Model', {
    type: GroupingsModel.TYPE,
    model: GroupingsModel
  });
  molten.addPlugin('ModelEditor', {
    type: GroupingsModel.TYPE,
    editor: GeoLayerEditor
  });
};
export default {
  install
};